import Filter from './Filter.js';
import Results from './Results.js';

class Main {
    constructor() {
        new Filter;
        new Results;

        // FIXME: We probably need an initial call to show some results
    }
}

export default Main;
